export default "__VITE_ASSET__7dd2b0c7__"